<template>
    <v-content>
        <v-row
            style="font-size: 1em; font-weight: 400; color: #212121; letter-spacing: 1px;"
            no-gutters
        >
            <v-col
                class="mx-3 text-center"
            >
                Perfect!
            </v-col>
            </v-row>
            <v-row
            justify="center"
            style="font-size: 1.2em; font-weight: 600; color: #212121; letter-spacing: 1px;"
            no-gutters
            >
            <v-col
                class="mx-3 mt-2 text-center"
            >
                Who are we feeding?
            </v-col>
        </v-row>

        <!--       Progress Tracker      -->
        <v-row
            justify="center"
            no-gutters
        >
        <v-col
            class="mx-5 pa-0"
            cols="8"
            xs="8"
            sm="6"
            md="5"
            lg="4"
            xl="4"
        >
            <v-stepper-header
            style="box-shadow: none;"
            >
            <v-stepper-step
                step="1"
                :complete="stepper > 1"
                color="#74cf74"
            />
            <v-divider></v-divider>
            <v-stepper-step
                step="2"
                :complete="stepper > 2"
                color="#74cf74"
            />
            <v-divider></v-divider>
            <v-stepper-step
                step="3"
                color="#74cf74"
            />
            </v-stepper-header>
        </v-col>
        </v-row>

        <!--            Input            -->
        <div
        class="bg5"
        >
            <v-row
                justify="center"
                no-gutters
            >
                <v-col
                    cols="12"
                    xs="12"
                    sm="10"
                    md="6"
                    lg="5"
                    xl="4"
                >

        <!--------------------------------->
        <!--    Dialog For Add Person    -->
        <!--------------------------------->
                    <v-dialog
                        v-model="newPerson"
                        persistent
                        width="500"
                    >
                        <template v-slot:activator="{ on }">


                    <!--------------------------------->
                    <!--       Person Iterator       -->
                    <!--------------------------------->
                        <v-expansion-panels
                            v-model="personSelection"
                            hover
                            popout
                            focusable
                            class="px-2"
                        >
                            <v-expansion-panel
                                v-for="(person,p) in people"
                                :key="p"
                            >

                    <!----------------------------------->
                    <!--    Dialog For Remove Person   -->
                    <!----------------------------------->
                                <v-dialog
                                    v-model="deletePerson"
                                    persistent
                                    width="500"
                                >
                                    <template v-slot:activator="{ on }">

                    <!--   Expansion Panel Header   -->
                                        <v-expansion-panel-header
                                            class="pl-2"
                                        >
                                            <v-row
                                                no-gutters
                                                align="center"
                                            >
                                            <v-col
                                                v-if="p > 0"
                                                class="shrink"
                                            >
                                                <v-btn
                                                    icon
                                                    class="white--text"
                                                    color = 'red'
                                                    @click.prevent="queueRemovePerson(person.name)"
                                                    v-on ="on"
                                                >
                                                    <v-icon
                                                        medium
                                                    >
                                                        delete_forever
                                                    </v-icon>
                                                </v-btn>
                                            </v-col>
                                            <v-col
                                                v-if="p == 0"
                                                class="shrink ml-1 mr-2"
                                            >
                                                <v-icon
                                                    color="#74cf74"
                                                    medium
                                                >
                                                    account_circle
                                                </v-icon>
                                            </v-col>
                                            <v-col
                                                class="ml-1"
                                                style="'font-size: 1em; font-weight: 500; color: #212121; letter-spacing: 1px"
                                            >
                                                    {{person.name}}
                                            </v-col>
                                            </v-row>
                                        </v-expansion-panel-header>

                                    </template>

                    <!--       Dialog Content       -->
                                    <v-card
                                        class="pb-5"
                                        style="overflow-y: hidden; overflow-x: hidden"
                                    >
                                        <v-row
                                            class="grey lighten-3"
                                        >
                                            <v-card-title
                                                class="headline ml-3"
                                                primary-title
                                            >
                                                Remove Person
                                            </v-card-title>
                                            <v-btn
                                                absolute
                                                small
                                                fab
                                                class="mr-3 text-right"
                                                style="top: 10px; right: 10px;"
                                                @click.prevent="cancelRemovePerson"
                                            >
                                            <v-icon>
                                                close
                                            </v-icon>
                                            </v-btn>
                                        </v-row>
                                        <v-row
                                            no-gutters
                                            class="my-5"
                                            justify="center"
                                        >
                                            Remove {{personName}}?
                                        </v-row>
                                        <v-row
                                            no-gutters
                                            justify="space-between"
                                            class="px-5"
                                        >
                                            <v-btn
                                                @click.prevent="cancelRemovePerson"
                                            >
                                                CANCEL
                                            </v-btn>
                                            <v-btn
                                                @click.prevent="removePerson(personName)"
                                            >
                                                REMOVE
                                            </v-btn>
                                        </v-row>
                                    </v-card>
                                </v-dialog>

                    <!--  Expansion Panel Content  -->
                                <v-expansion-panel-content>
                                    <v-container flex>
                                    <v-row>
                                        <v-text-field
                                            v-model="person.name"
                                            :label="p == 0 ? 'Your Name' : 'Name'"
                                            class="mx-2 mt-5 mb-0 pa-0"
                                            v-on:input="personChangeMade([p,'update'])"
                                        ></v-text-field>
                                    </v-row>

                                    <v-row
                                        class="flex-nowrap"
                                    >
                                        <v-col
                                            cols="6"
                                            class="ma-0 pa-0"
                                        >                
                                            <v-text-field
                                                v-model="person.birth_year"
                                                label="Birth Year"
                                                type="number"
                                                class="mx-2 my-0 pa-0"
                                                v-on:input="personChangeMade([p,'update'])"
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="6"
                                            class="ma-0 pa-0"
                                        >
                                            <v-select
                                                v-model="person.gender"
                                                :items="['M','F']"
                                                label="Gender"
                                                class="mx-2 my-0 pa-0"
                                                v-on:input="personChangeMade([p,'update'])"
                                            ></v-select>
                                        </v-col>
                                    </v-row>

                                    <v-row
                                        v-if="(new Date().getFullYear() - person.birth_year) >= 16"
                                        class="flex-nowrap"
                                    >
                                        <v-col
                                            cols="6"
                                            class="ma-0 pa-0"
                                        >
                                            <v-text-field
                                            v-model="person.height_ft"
                                            label="Ft"
                                            type="number"
                                            suffix="ft"
                                            class="mx-2 my-0 pa-0"
                                            v-on:input="personChangeMade([p,'update'])"
                                            ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="6"
                                            class="ma-0 pa-0"
                                        >
                                            <v-text-field
                                            v-model="person.height_in"
                                            label="In"
                                            type="number"
                                            suffix="in"
                                            class="mx-2 my-0 pa-0"
                                            v-on:input="personChangeMade([p,'update'])"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row
                                        v-if="(new Date().getFullYear() - person.birth_year) >= 16"
                                    >
                                        <v-col
                                            cols="6"
                                            class="ma-0 pa-0"
                                        >
                                        <v-text-field
                                            v-model="person.weight_lb"
                                            label="Weight (lb)"
                                            type="number"
                                            suffix="lbs"
                                            class="mx-2 my-0 pa-0"
                                            v-on:input="personChangeMade([p,'update'])"
                                        ></v-text-field>
                                        </v-col>

                                        <v-col
                                            cols="6"
                                            class="ma-0 pa-0"
                                        >
                                            <v-text-field
                                                v-model="person.goal_weight"
                                                label="Goal Weight"
                                                type="number"
                                                suffix="lbs"
                                                class="mx-2 my-0 pa-0"
                                                v-on:input="personChangeMade([p,'update'])"
                                            ></v-text-field>
                                        </v-col>
                                    </v-row>

                                    <v-row
                                        v-if="!((new Date().getFullYear() - person.birth_year) < 16)"
                                    >
                                        <v-select
                                        v-model="person.activity_level"
                                        :items="['sedentary','light','active','very active']"
                                        label="Activity Level"
                                        class="mx-2 my-0 pa-0"
                                        v-on:input="personChangeMade([p,'update'])"
                                        ></v-select>
                                    </v-row>

                                    <v-row
                                        v-else
                                    >
                                        <v-select
                                        v-model="person.activity_level"
                                        :items="['light','active','very active']"
                                        label="Activity Level"
                                        class="mx-2 my-0 pa-0"
                                        v-on:input="personChangeMade([p,'update'])"
                                        ></v-select>
                                    </v-row>

                                    <v-row>
                                        <v-text-field
                                            v-model="person.daily_calorie_target"
                                            label="Daily Calories"
                                            type="number"
                                            class="mx-2 my-0 pa-0"
                                            hide-details
                                            v-on:input="personChangeMade([p,'update'])"
                                        ></v-text-field>
                                    </v-row>
                                    <v-row
                                        justify="center"
                                        class="mt-1 pa-0"
                                    >
                                        <v-col
                                            class="ma-0 pa-0"
                                            style="font-size: 0.8em; font-weight: 300; color: #212121; letter-spacing: 1px; text-align: center;"
                                        >
                                            Suggested: {{person.suggested_calories}}
                                        </v-col>
                                    </v-row>

                                    </v-container>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>

                    <!--------------------------------->
                    <!--      Add Person Dialog      -->
                    <!--------------------------------->
                            <v-row
                                class="mt-5 mb-7 mx-5"
                                justify="center"
                                no-gutters
                            >
                                <v-btn
                                    dark
                                    color="#74cf74"
                                    @click.prevent="addNewPerson"
                                    v-on="on"
                                    elevation="5"
                                >
                                    <v-row
                                        align="center"
                                        no-gutters
                                    >
                                        <v-col
                                            class="shrink ma-0 pa-0"
                                        >
                                            <v-icon medium color="white">
                                                person_add
                                            </v-icon>
                                        </v-col>
                                        <v-col
                                            v-if="people.length < 1"
                                            class="ml-2 pa-0"
                                        >
                                            Add Self
                                        </v-col>
                                        <v-col
                                            v-else
                                            class="ml-2 pa-0"
                                        >
                                            Add Person
                                        </v-col>
                                    </v-row>
                                </v-btn>
                            </v-row>
                        </template>

                    <!--   Add Person Dialog Content   -->
                        <AddPerson/>
                    </v-dialog>
            
        <!--          Navigation         -->
                    <v-row
                        no-gutters
                        class="mx-5"
                        justify="space-between"
                    >
                        <v-btn
                            class="btn2 mr-2"
                            @click="stepper = stepper - 1"
                            color = #74cf74
                        >
                            Back
                        </v-btn>
                        <v-btn
                            class="btn2 ml-2"
                            @click="next"
                            color = #74cf74
                            :disabled="disableStep2Next"
                        >
                            Next
                        </v-btn>
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </v-content>
</template>

<script>
import AddPerson from '@/components/people/AddPerson.vue'
        
    export default {
        components: {
            AddPerson,
        },

        data: () => ({
            personSelection: [],
            deletePerson: false,
            personName: null,
        }),

        methods: {
            next() {
                this.stepper = this.stepper + 1;
            },

            addNewPerson() {
                this.$store.dispatch('data/resetSuggestedCalories');
                this.newPerson = true
            },

            cancelRemovePerson() {
                this.deletePerson = false;
                this.personSelection = null;
                this.personName = null;
            },

            personChangeMade: function(value) {
                this.$store.dispatch('data/peopleChangeMade',value);
            },

            //section previously commented out, not sure why... don't remember
            // updatePerson: function(value) {
            //     this.$store.dispatch('signup/updatePeople',value); //NEED TO UPDATE VALUE TO BE CORRECT *****
            //     this.$store.dispatch('signup/peopleChangeMade',[value[9],false]); //NEED TO UPDATE VALUE TO BE CORRECT *****
            //     this.personSelection = null;
            // },

            queueRemovePerson(value){
                this.deletePerson = true;
                this.personName = value;
            },

            removePerson(value) {
                this.$store.dispatch('data/removePeople',value);
                this.deletePerson = false;
                this.personName = null;
            }
        },

        computed: {
            stepper: {
                get() {
                    return this.$store.getters['data/stepper'];
                },
                set(value) {
                    this.$store.dispatch('data/updateStepper',value);
                }
            },

            newPerson: {
                get() {
                    return this.$store.getters['data/newPerson'];
                },
                set(value) {
                    this.$store.dispatch('data/updateNewPerson',value);
                }
            },
            

            people() {
                return this.$store.getters['data/people'];
            },

            disableStep2Next() {
                if (this.people.length < 1) {
                    return true
                } else {
                    return false
                }
            },

            height() {
                return ((this.heightFt * 12) + Number(this.heightIn))
            },

            suggestedCalories() {
                return this.$store.getters['data/suggestedCalories'];
            },            
        },


    }
</script>

<style scoped>
  .btn2 {
    font-family: "Noto Serif TC", serif;
    font-size: 0.9em;
    font-weight: 600;
    color: #ffffff;
    text-align: center;
  }

  .btn3 {
    font-size: 0.9em;
    width: 100%;
    min-height: 48px;
    font-weight: 400;
    text-align: center;
  }

  a {
    text-decoration: none;
    color: #74cf74 !important;
    font-weight: 600;
  }
</style>